import { apiClient } from '@/shared/lib/apiClient';
import type { ApiResponse, Booking, PaginatedResponse } from '@/types';

export interface GuideBookingListParams {
  page?: number;
  limit?: number;
  status?: string;
  statuses?: string;
  sortBy?: string;
}

export const guideBookingsApi = {
  async list(params?: GuideBookingListParams) {
    const response = await apiClient.get<PaginatedResponse<Booking>>('/guide/bookings', {
      params,
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await apiClient.get<ApiResponse<Booking>>(`/guide/bookings/${id}`);
    return response.data.data!;
  },

  async completeBooking(id: string) {
    const response = await apiClient.post<ApiResponse<Booking>>(`/guide/bookings/${id}/complete`);
    return response.data.data!;
  },
};

export const guideBookingsKeys = {
  all: ['guide-bookings'] as const,
  list: (params?: GuideBookingListParams) => [...guideBookingsKeys.all, 'list', params] as const,
  detail: (id: string) => [...guideBookingsKeys.all, 'detail', id] as const,
};
